module.exports = __webpack_public_path__ + "media/images/Web_Rewards-371adda698ba34c8e9e446cb191516f4.png";